
<script>
import { Line } from 'vue-chartjs'

export default {
    extends: Line,
    props: {
        data: Object,
        country: {
            type: String,
            default: ""
        }
    },
    data() {

        // For online panels, if we lost path of /panel/ we must have an empty
        // Zone in the graph. We also need a delay of 24 hours to ensure we lost
        // the path
        let vtime = {
            minUnit: 'day',
            displayFormats: {
            'millisecond': 'MMM DD',
            'second': 'MMM DD',
            'minute': 'MMM DD',
            'hour': 'MMM DD',
            'day': 'MMM DD',
            'week': 'MMM DD',
            'month': 'MMM DD',
            'quarter': 'MMM DD',
            'year': 'MMM DD',
            }
        }
        let dInfect = this.getDataInfection(this.data.data);
        let lastK = Object.keys(dInfect)[Object.keys(dInfect).length - 1];
        let delay = Date.now() - (lastK+"000");
        delay = delay/1000/60/60;  // In hours
        if (this.data.status !== "offline" && delay > 24){ // Online and last > 24h
            vtime.max = new Date();
        }
        return {
            gridColor: "rgba(0,0,0,0.4)",
            chartFontColor: "rgba(255,255,255,0.7)",
            options: {
                maintainAspectRatio: false,
                legend: {
                    labels: {
                        fontColor: this.chartFontColor,
                        fontSize: 18
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            fontColor: this.chartFontColor,
                            fontSize: 16,
                            beginAtZero: true
                        },
                        gridLines: {
                            color: this.gridColor
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            fontColor: this.chartFontColor,
                            fontSize: 15
                        },
                        type: 'time',
                        time: vtime,
                        gridLines: {
                            color: this.gridColor
                        }
                    }]
                }
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    },
    watch: {
        chartData() {
            this.renderChart(this.chartData, this.options)
        }
    },
    computed: {
        chartData() {
            let infection = this.getDataInfection(this.data.data, this.country)
            let chart_data = []
            let data_labels = []
            let label = ""
            if (this.country === "") {
                label = "Infected people through time all over the world"
            }
            else {
                label = "Infected people through time in: " + this.$const.countries[this.country].name
            }
            for(let key in infection){
                chart_data.push(infection[key]);
                data_labels.push(new Date(key * 1000));
            }
            return {
                labels: data_labels,
                datasets: [{
                    label: label,
                    data: chart_data,
                    backgroundColor: "rgba(227, 199, 143, 0.2)",
                    borderColor: "rgba(227, 199, 143, 0.5)"
                }]
            }
        }
    },
    methods: {
        getDataInfection(data, searched_country="", start=null, end=null){
            /*
             Parse a list of data and return a dict with number of infection
             per days for a given country (or all country if not search_country)
            @return: Dict {"timestamp":value}
            @example: {"1575241200": 263, "1575327600": 606, "1575414000": 913}
             */

            let infected_dict = {}
            if(data.length > 0){ // at least one record
                data.forEach(d => {  // For each days
                    if("country" in d){
                        let date = this.getTimeOfDay(d["date"])
                        // Check if date match [start;end]
                        if((start == null || date >= start) && (end == null || date <= end)){
                            let infected_nb = 0
                            let country = d["country"]
                            if(searched_country == ""){  // Every country
                                for(let key in country){
                                    infected_nb += country[key]
                                }
                            }
                            else if (searched_country in country){  // Specified country
                                infected_nb += country[searched_country]
                            }
                            infected_dict[date.toString()] = infected_nb
                        }
                    }
                })
            }
            return infected_dict
        },
        getTimeOfDay(t){
            /* Get a timestamp (int) and return the timestamp of the day (int) */
            let d = new Date(t * 1000)
            d.setHours(0, 0, 0, 0)
            return d.getTime() / 1000
        }
    }
}

</script>

<style lang="scss" scoped>

</style>
